import { GlFormInput } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { __ } from '~/locale';
export default {
    name: 'ReplyPlaceholder',
    components: {
        GlFormInput
    },
    props: {
        placeholderText: {
            type: String,
            required: false,
            default: __('Reply…')
        },
        labelText: {
            type: String,
            required: false,
            default: __('Reply to comment')
        }
    },
    emits: [
        'focus'
    ]
};
